import { render, staticRenderFns } from "./BusPathTable.vue?vue&type=template&id=2077c896&"
import script from "./BusPathTable.vue?vue&type=script&lang=js&"
export * from "./BusPathTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports